export function GetTime(date: Date | string | number | undefined): number {
  if (!date) return Date.now();
  if (typeof date === "string") return new Date(date).getTime();
  if (typeof date === "number") return date;
  return date.getTime();
}
